<template>
  <div>
    <van-popup v-model="showShare" position="bottom" @close="onClose">
      <div class="footer" style="z-index:10000">
        <div class="footer-tile">{{reward > 0 ? '分享后预计最高可赚取￥'+reward : '分享给好友'}}</div>
        <!--                <div class='footer-desc' @click="onRule">了解规则 &gt;&gt;</div>-->
        <div class="footer-btn flex-start">
          <div class="footer-one-btn" @click="goPoster">
            <img
              class="footer-one-img"
              src="https://static.dierqudao.com/images/icon-share-qrcode.png"
            />
            <div class="footer-one-text gray">海报</div>
          </div>
          <div class="footer-one-btn" @click="onWeixinTimeLine">
            <img
              class="footer-one-img"
              src="https://static.dierqudao.com/images/icon-pengyouquan.png"
            />
            <div class="footer-one-text gray">朋友圈</div>
          </div>
          <div class="footer-one-btn" @click="onWeixinFriend">
            <img
              class="footer-one-img"
              src="https://static.dierqudao.com/images/icon-share-weixin.png"
            />
            <div class="footer-one-text gray">微信好友</div>
          </div>
          <div
            class="footer-one-btn"
            v-clipboard:copy="share.get_url"
            v-clipboard:success="onCopyUrl"
            v-clipboard:error="onError"
          >
            <img
              class="footer-one-img"
              src="https://static.dierqudao.com/images/icon-share-copy.png"
            />
            <div class="footer-one-text gray">复制链接</div>
          </div>
        </div>
        <div class="cancle" @click="onClose">取消</div>
      </div>
    </van-popup>

    <div class="shareShow" v-if="showWxShare" @click="cancleShare">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast, Popup } from "vant";

Vue.use(Toast).use(Popup);
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    reward: {
      type: Number,
      default: 0
    },
    goods_id: {
      type: Number,
      default: 0
    },
    share: {
      type: Object,
      default: {}
    }
  },
  watch: {
    show(val) {
      // console.log(val)
      this.showShare = val;
    }
  },
  data: function() {
    return {
      showWxShare: false,
      showShare: false
    };
  },
  methods: {
    onRule() {
      this.$router.push({
        path: "/index/contentdetail",
        query: {
          id: 8
        }
      });
    },

    // 海报
    goPoster() {
      rbLink({
        name: "PostDownload",
        query: {
          goods_id: this.goods_id
        }
      });
    },

    onWeixinFriend() {
      let that = this;
      let share = that.share;
      if (window.isApp()) {
        appEvent({
          name: "shareWeixinFriend",
          query: share
        });
      } else {
        this.showWxShare = true;
      this.onClose();
      }
    },
    onWeixinTimeLine() {
      let that = this;
      let share = that.share;
      if (window.isApp()) {
        appEvent({
          name: "shareWeixinTimeLine",
          query: share
        });
      } else {
        this.showWxShare = true;
      this.onClose();
      }
    },
    goWeixin() {
      this.showWxShare = true;
      this.onClose();
    },

    cancleShare() {
      this.showWxShare = false;
    },

    // 复制短连接
    onCopyUrl() {
      Toast.success("复制成功");
      this.onClose();
    },

    onError() {
      Toast("复制失败");
    },

    onClose() {
      this.$emit("shareCancel", {}); //取消
    }
  }
};
</script>

<style scoped>
.shareShow {
  position: fixed;
  text-align: center;
  width: 100%;
  height: 100%;
  z-index: 10000;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.68);
  color: rgb(255, 255, 255);
}

.shareShow div {
  background: url(https://static.dierqudao.com/images/cheesemanv2.0/icon_share_arrow.png)
    no-repeat right top;
  height: 100%;
  background-size: 100px;
  padding: 180px 0 0 0;
  margin: 10px;
  line-height: 40px;
}

.shareShow h2 {
  /*font-size: 1.8rem*/
  font-size: 0.8rem;
}

.shareShow p {
  font-size: 1.4rem;
}

.shareShow span {
  font-size: 1.4rem;
  padding: 4px;
  border: 1px solid #fff;
  border-radius: 4px;
}

.footer-tile {
  font-size: 17px;
  text-align: center;
  color: #333;
  padding: 15px;
}

.footer-desc {
  color: #999999;
  text-align: center;
  border-bottom: 1px solid #efefef;
  padding-bottom: 10px;
}

.footer {
  background: #fff;
  z-index: 100;
}

.footer-one-btn {
  flex: 1;
  height: 82px;
  margin: 15px 0;
  display: flex;
  align-content: space-between;
  justify-content: center;
  flex-wrap: wrap;
  border-radius: 0;
  border: 0;
  background: #fff;
  /* position: static; */
}

/*button::after {
        border: none;
    }*/

.footer-one-text {
  text-align: center;
  font-size: 12px;
  width: 100%;
}

.footer-one-img {
  width: 48px;
  height: 48px;
}

.cancle {
  width: 336px;
  height: 44px;
  background: rgba(253, 40, 64, 1);
  border-radius: 6px;
  font-size: 16px;
  color: #fff;
  line-height: 44px;
  margin: 15px auto 15px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// ShareDialog.vue?705e028a